<template>
    <button type="button" class="u-icon-button"  v-tooltip.top="tooltip">
        <suspense>
            <u-icon :showTimer="showTimer" :image="image" ref="timer"/>           
        </suspense>
    </button>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import UIcon from '@/components/common/UIcon.vue'

export default defineComponent({
    components: { UIcon },
    props: {
        image: String,
        showTimer: Boolean, 
        tooltip: String
    },
    setup(props){
        const timer = ref(null);
        function resetCounter (){
            if(props.showTimer){
                Object(timer.value).resetCounter();
            }
        }
        return {resetCounter, timer}
    }
})
</script>
